<script lang="ts">
    import { _ } from "svelte-i18n"
    import FormInputText from "../../../widgets/Form/FormInputText.svelte"
    import EngravingPreview from "../widgets/EngravingPreview.svelte"

    let {
        product,
        user_inputs = $bindable(),
    }: {
        product: Product
        user_inputs: CartUserInputs
    } = $props()
</script>

<form class="gravur_fields">
    <div class="row">
        {#if product.user_inputs?.engraving_line_length_1}
            {#if product.lasersheet_configurator}
                <!-- TODO evaluate flag for preview -->
                <div class="col-md-12" style="padding-bottom: 0px;">
                    <EngravingPreview
                        line1={user_inputs.engraving_line_1}
                        line2={user_inputs.engraving_line_2}
                        line3={user_inputs.engraving_line_3}
                    />
                </div>
            {/if}
            <div class="col-md-6">
                <FormInputText
                    name="gravur_zeile1"
                    label={$_("product.engraving-line-1")}
                    bind:value={user_inputs.engraving_line_1}
                    maxlength={product.user_inputs?.engraving_line_length_1}
                />
                <div class="infotext">
                    {@html $_("product.count-characters-left-html", {
                        values: {
                            count:
                                product.user_inputs?.engraving_line_length_1 -
                                (user_inputs.engraving_line_1?.length || 0),
                        },
                    })}
                </div>
            </div>
        {/if}
        {#if product.user_inputs?.engraving_line_length_2}
            <div class="col-md-6">
                <FormInputText
                    name="gravur_zeile2"
                    label={$_("product.engraving-line-2")}
                    bind:value={user_inputs.engraving_line_2}
                    maxlength={product.user_inputs?.engraving_line_length_2}
                />
                <div class="infotext">
                    {@html $_("product.count-characters-left-html", {
                        values: {
                            count:
                                product.user_inputs?.engraving_line_length_2 -
                                (user_inputs.engraving_line_2?.length || 0),
                        },
                    })}
                </div>
            </div>
        {/if}
        {#if product.user_inputs?.engraving_line_length_3}
            <div class="col-md-6">
                <FormInputText
                    name="gravur_zeile3"
                    label={$_("product.engraving-line-3")}
                    bind:value={user_inputs.engraving_line_3}
                    maxlength={product.user_inputs?.engraving_line_length_3}
                />
                <div class="infotext">
                    {@html $_("product.count-characters-left-html", {
                        values: {
                            count:
                                product.user_inputs?.engraving_line_length_3 -
                                (user_inputs.engraving_line_3?.length || 0),
                        },
                    })}
                </div>
            </div>
        {/if}
    </div>
</form>
